import React from 'react'
import { 
  FaUser, 
  FaPhoneAlt, 
  FaMapMarkerAlt, 
  FaMap, 
  FaCity, 
  FaStickyNote,
  FaPalette,
  FaRulerVertical,
  FaTshirt,
  FaShoppingCart,
  FaTruck,
  FaMoneyBillWave
} from "react-icons/fa";

const HelpSectuion = () => {
  return (
    <>
       <div className="mt-8 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center">
                <div className="inline-block p-3 bg-blue-100 rounded-full mb-3">
                    <FaPhoneAlt className="text-blue-600 text-2xl" />
                </div>
                <h4 className="font-bold text-gray-800 mb-1">২৪/৭ সাপোর্ট</h4>
                <p className="text-sm text-gray-600">কোন প্রশ্ন থাকলে কল করুন</p>
                </div>
                <div className="text-center">
                <div className="inline-block p-3 bg-green-100 rounded-full mb-3">
                    <FaTruck className="text-green-600 text-2xl" />
                </div>
                <h4 className="font-bold text-gray-800 mb-1">সারা বাংলাদেশ ডেলিভারি</h4>
                <p className="text-sm text-gray-600">২-৫ কার্যদিবসের মধ্যে ডেলিভারি</p>
                </div>
                <div className="text-center">
                <div className="inline-block p-3 bg-purple-100 rounded-full mb-3">
                    <FaMoneyBillWave className="text-purple-600 text-2xl" />
                </div>
                <h4 className="font-bold text-gray-800 mb-1">সহজ পেমেন্ট</h4>
                <p className="text-sm text-gray-600">পণ্য পেয়ে টাকা দিন</p>
                </div>
            </div>
        </div>
    </>
  )
}

export default HelpSectuion
